export const YesNoOptions = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const VODArchiveTimeOptions = [
  { label: '14 Days', value: '14' },
  { label: '30 Days', value: '30' },
  { label: '60 Days', value: '60' },
];

export const StreamCheckInTimeOptions = [
  { label: '15 min. prior', value: '15' },
  { label: '30 min. prior', value: '30' },
  { label: '45 min. prior', value: '45' },
  { label: '60 min. prior', value: '60' },
];
export const PPVPriceOptions = [
  { label: '$0.99', value: '0.99' },
  { label: '$4.99', value: '4.99' },
  { label: '$9.99', value: '9.99' },
  { label: '$14.99', value: '14.99' },
  { label: '$19.99', value: '19.99' },
  { label: '$24.99', value: '24.99' },
  { label: '$29.99', value: '29.99' },
  { label: '$34.99', value: '34.99' },
  { label: '$39.99', value: '39.99' },
  { label: '$44.99', value: '44.99' },
  { label: '$49.99', value: '49.99' },
];

export const NewStreamTypeOptions = [
  { label: 'Embed', value: 'embed_only', disable: false, icon: `embedIcon` },
  { label: 'KLıC', value: 'klic_only', disable: false },
  { label: 'KLıC Ix Road Case', value: 'road_case', disable: false },
  {
    label: 'KLıC + Embed',
    value: 'klic_embed',
    disable: false,
    icon: `klicEmbedIcon`,
  },
  { label: 'KLıC + Ix Road Case', value: 'klic_road_case', disable: false },
  {
    label: 'KLıC + Ix Road Case + Embed',
    value: 'klic_road_case_embed',
    disable: false,
  },
];

export const MultiStreamNamesOptions = [
  { label: 'Always On', value: 'always_on', disable: false },
  { label: 'Hover Only', value: 'hover_only', disable: false },
];

export const ContentTypeOption = [
  { label: 'Public', value: 'Public', disable: false },
  { label: 'Private', value: 'Private', disable: false },
  { label: 'Follower Only', value: 'Follower', disable: false },
  // { label: 'Subscriber Only', value: 'Subscriber', disable: false },
];
export const PlatformOption = [
  { label: 'PC', value: 'PC' },
  { label: 'PS4', value: 'PS4' },
  { label: 'PS5', value: 'PS5' },
  { label: 'XBOX ONE', value: 'XBOX ONE' },
  { label: 'SERIES X', value: 'SERIES X' },
  { label: 'NINTENDO', value: 'NINTENDO' },
  { label: 'Cross-Platform', value: 'Cross-Platform' },
  { label: 'Mobile', value: 'Mobile' },
  { label: 'IRL', value: 'IRL' },
];
export const SortByViewerOptions = [
  { label: 'High To Low', value: 'DESC' },
  { label: 'Low To High', value: 'ASC' },
];

export const CategorySortByOptions = [
  { label: 'A-Z', value: 'ATOZ' },
  { label: 'Z-A', value: 'ZTOA' },
  { label: 'High To Low', value: 'HTOL' },
  { label: 'Low To High', value: 'LTOH' },
];

export const SortByEditorOptions = [
  { label: 'All', value: 'RMA' },
  { label: 'Editor', value: 'RME' },
  { label: 'Moderator', value: 'RMM' },
];
export const SortByOrderOptions = [
  { label: 'All', value: 'ALL' },
  { label: 'Pay Per View', value: 'EVT' },
  { label: 'Subscription', value: 'SUBS' },
];
export const BraketologyTypeOption = [
  { label: 'CHALLONGE EMBED', value: 'challonge_embed' },
  // { label: 'TOORNAMENT EMBED', value: 'toornament_embed' },
  { label: 'BATTLEFY EMBED', value: 'battlefy_embed' },
  {
    label: 'KLIC BRACKETS', // NOTE: should this be KLiC as well?
    value: 'klic_brackets_subscriber_only',
  },
];
export const RoadCaseOptions = [
  { label: 'Input 1', value: 'RC1' },
  { label: 'Input 2', value: 'RC2' },
  { label: 'Input 3', value: 'RC3' },
  { label: 'Input 4', value: 'RC4' },
  { label: 'Input 5', value: 'RC5' },
  { label: 'Input 6', value: 'RC6' },
  { label: 'Input 7', value: 'RC7' },
  { label: 'Input 8', value: 'RC8' },
  { label: 'Input 9', value: 'RC9' },
  { label: 'Input 10', value: 'RC10' },
  { label: 'Input 11', value: 'RC11' },
  { label: 'Input 12', value: 'RC12' },
  { label: 'Input 13', value: 'RC13' },
  { label: 'Input 14', value: 'RC14' },
  { label: 'Input 15', value: 'RC15' },
  { label: 'Input 16', value: 'RC16' },
];
export const MonetizationType = [
  // { label: 'Advertisements', value: 'advertisements', disable: false },
  // { label: 'Donations', value: 'contributors',disable:false },
  { label: 'None', value: 'none', disable: false },
  { label: 'Subscriber Only', value: 'Subscriber', disable: false },
  { label: 'Pay-Per View', value: 'payPerView', disable: false },
];

export const adLengthOption = [
  { label: '15 Seconds', value: '15' },
  { label: '30 Seconds', value: '30' },
  { label: '45 Seconds', value: '30' },
  { label: '60 Seconds', value: '60' },
];

export const ContributorsOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
];

export const FreePreviewTime = [
  { label: '1 Minute', value: '1 Minute' },
  { label: '2 Minutes', value: '2 Minutes' },
  { label: '3 Minutes', value: '3 Minutes' },
  { label: '4 Minutes', value: '4 Minutes' },
  { label: '5 Minutes', value: '5 Minutes' },
];

export const PriceInputOptions = [
  { label: 'Exact Amount', value: 'exactAmount' },
  { label: 'Price Range', value: 'priceRange' },
];

export const StreamTypeOptions = [
  { label: 'KLiC', value: 'klic' },
  { label: 'KICK', value: 'kick' },
  { label: 'Twitch', value: 'twitch' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Discord', value: 'discord' },
];

export const StreamChatsPerStream = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
];

export const ChatTypeOptions = [
  { label: 'KLiC', value: 'klic' },
  { label: 'KICK', value: 'kick' },
  { label: 'Twitch', value: 'twitch' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Facebook', value: 'facebook' },
  { label: 'Discord', value: 'discord' },
];

export const RoleOptions = [
  { label: 'Moderator', value: 'moderator' },
  { label: 'Editor', value: 'editor' },
];

export const SubscribeOptions = [
  { label: '1 Month', value: 'month', price: '3.99' },
  { label: '3 Month', value: '3_month', price: '9.99' },
  { label: '6 Month', value: '6_month', price: '19.99' },
  { label: '12 Month', value: '12_month', price: '39.99' },
];

export const MonthList = [
  { label: 'January', value: '01' },
  { label: 'February', value: '02' },
  { label: 'March', value: '03' },
  { label: 'April', value: '04' },
  { label: 'May', value: '05' },
  { label: 'June', value: '06' },
  { label: 'July', value: '07' },
  { label: 'August', value: '08' },
  { label: 'September', value: '09' },
  { label: 'October', value: '10' },
  { label: 'November', value: '11' },
  { label: 'December', value: '12' },
];

export const DayList = [
  { label: '01', value: '01' },
  { label: '02', value: '02' },
  { label: '03', value: '03' },
  { label: '04', value: '04' },
  { label: '05', value: '05' },
  { label: '06', value: '06' },
  { label: '07', value: '07' },
  { label: '08', value: '08' },
  { label: '09', value: '09' },
  { label: '10', value: '10' },
  { label: '11', value: '11' },
  { label: '12', value: '12' },
  { label: '13', value: '13' },
  { label: '14', value: '14' },
  { label: '15', value: '15' },
  { label: '16', value: '16' },
  { label: '17', value: '17' },
  { label: '18', value: '18' },
  { label: '19', value: '19' },
  { label: '20', value: '20' },
  { label: '21', value: '21' },
  { label: '22', value: '22' },
  { label: '23', value: '23' },
  { label: '24', value: '24' },
  { label: '25', value: '25' },
  { label: '26', value: '26' },
  { label: '27', value: '27' },
  { label: '28', value: '28' },
  { label: '29', value: '29' },
  { label: '30', value: '30' },
  { label: '31', value: '31' },
];
export const monthlyPricing = {
  free: 0,
  creator: 49,
  organizer: 99,
  host: 149,
};
export const yearlyPricing = {
  free: 0,
  creator: 490,
  organizer: 990,
  host: 1490,
};
export const monthlyPricingPlan = {
  free: '',
  creator: 'RNW5NZKWQAN744SLOEWOBZJV',
  organizer: 'S2I7XUMRVBJYRQPHSLEKAK3Y',
  host: 'IWF5JXD4OOMU7VYH5YPQQVGT',
};

// export const monthlyPricingPlan = {
//   free: '',
//   creator: 'LQHN6UQFTCMWNAB4EP6CJJ7L',
//   organizer: '4L5ECSQT6M7A33V7JA447SSM',
//   host: 'LB64ITMGT5VJLK5ONV4LFXZA',
// };
export const yearlyPricingPlan = {
  free: '',
  creator: 'GSNGLL65FEX2DXZKUUXCEISA',
  organizer: '7Z5UOLWPJMJJSAVU4ZSVSKB4',
  host: 'JOCNG7HTZ2RPFPIXBPKONLSU',
};

export const MonthDayList = (number = 31) => {
  const dayList = [];
  for (let i = 1; i <= number; i++) {
    let data = { label: i < 10 ? `0${i}` : i, value: i < 10 ? `0${i}` : i };
    dayList.push(data);
  }
  return dayList;
};
